import React from 'react'
import PropTypes from 'prop-types'

const Footer = (props) => (
    <footer id="footer" style={props.timeout ? {display: 'none'} : {}}>
        <p className="copyright">
            &copy; fibeRSwITch - { new Date().getFullYear() }.
            {` `}
            Basis-template van:  {` `}
                <a href="https://html5up.net" target="_blank" rel="noopener noreferrer">HTML5 UP</a>. 
            Gebouwd met: {` `}
                <a href="https://www.gatsbyjs.org/" target="_blank" rel="noopener noreferrer">Gatsby.js</a>.
        </p>
        <p className="copyright">
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">sitemap</a>.
        </p>
    </footer>
)

Footer.propTypes = {
    timeout: PropTypes.bool
}

export default Footer
